import { useEffect, useState } from "react";
/**
 * Returns a value from the values array corresponding to the first matching media query in the queries array, or undefined if there are no matches.
 */
export const useMedia = (
/** List of media queries */
queries, 
/** Values to return given that the corresponding media query matches */
values) => {
    const [value, setValue] = useState();
    useEffect(() => {
        const mediaQueryLists = queries.map((q) => window.matchMedia(q));
        const getValue = () => {
            const index = mediaQueryLists.findIndex((mql) => mql.matches);
            return values?.[index];
        };
        setValue(getValue);
        const handler = () => setValue(getValue);
        mediaQueryLists.forEach((mql) => mql.addListener(handler));
        return () => mediaQueryLists.forEach((mql) => mql.removeListener(handler));
    }, [queries, values]);
    return value;
};
//# sourceMappingURL=index.js.map